import { render, staticRenderFns } from "./ContactListView.vue?vue&type=template&id=29b5a96a"
import script from "./ContactListView.vue?vue&type=script&lang=js"
export * from "./ContactListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29b5a96a')) {
      api.createRecord('29b5a96a', component.options)
    } else {
      api.reload('29b5a96a', component.options)
    }
    module.hot.accept("./ContactListView.vue?vue&type=template&id=29b5a96a", function () {
      api.rerender('29b5a96a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contact/ContactListView.vue"
export default component.exports